<tt-page>
    <tt-page-heading> {{ webpageHeading }}</tt-page-heading>
    <tt-project-menu [params]="params" (getLoaded)="setHeading($event)"></tt-project-menu>
</tt-page>
